import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { BOOKING_URL } from './Navbar';
const SEASON_IMAGES = {
  verano: 'https://cdn.magicpatterns.com/uploads/2o3JJvfvN1sndfPm9H5UFq/Afueras_edificio.jpg',
  invierno: 'https://cdn.magicpatterns.com/uploads/rkySDngYrKMUi148u7ZR7g/Afuera_nieve_sin_obelisco2B.jpg'
};

/** Hemisferio sur: mayo a septiembre se muestra la foto con nieve */
function getSeason(): 'verano' | 'invierno' {
  const month = new Date().getMonth();
  return month >= 4 && month <= 8 ? 'invierno' : 'verano';
}
export function Hero() {
  const {
    t
  } = useLanguage();
  const season = getSeason();
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-215" data-mp="ncgk2fc4optq">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-216" data-mp="3d2bidl8y6rtf">
        <img src={SEASON_IMAGES[season]} alt={season === 'invierno' ? t('Frente de Cabañas Clarita cubierto de nieve en invierno', 'Front of Cabañas Clarita covered in snow in winter') : t('Frente de Cabañas Clarita en Dina Huapi en un día soleado', 'Front of Cabañas Clarita in Dina Huapi on a sunny day')} className="w-full h-full object-cover" data-id="element-217" data-mp="382fdzkwc8ydc" />
        <div className="absolute inset-0 bg-primary-dark/55" data-id="element-218" data-mp="30h9cdu1225nt" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16" data-id="element-219" data-mp="3599f1u8ifco3">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl mx-auto" data-id="element-220" data-mp="2qkdboaheentt">
          <span className="block text-white/90 text-sm md:text-base font-medium tracking-widest uppercase mb-4" data-id="element-221" data-mp="2hk85u4rurxhr">
            {t('Dina Huapi · Patagonia Argentina', 'Dina Huapi · Argentine Patagonia')}
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight text-balance" data-id="element-222" data-mp="nbba6qtxtx1l">
            Cabañas Clarita
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto font-light text-balance" data-id="element-223" data-mp="icrmolzp4d74">
            {t('Disfrute de vistas únicas a montañas y paisajes increíbles en la Patagonia Argentina.', 'Enjoy unique mountain views and incredible landscapes in Argentine Patagonia.')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-224" data-mp="112g89ohnqh9t">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-accent text-white rounded-full font-medium text-lg whitespace-nowrap hover:bg-accent-light transition-colors shadow-lg" data-id="element-225" data-mp="x14ldqq64a5b">
              {t('Reservar', 'Book Now')}
            </a>
            <a href="#cabanas" className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-lg whitespace-nowrap hover:bg-white/20 transition-colors" data-id="element-226" data-mp="1xb5o89ocuje0">
              {t('Ver las cabañas', 'View the cabins')}
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8,
      duration: 0.3
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-227" data-mp="2g1wyddg62dtg">
        <span className="text-white/70 text-xs uppercase tracking-widest mb-2" data-id="element-228" data-mp="2u03k5v7ucncr">
          {t('Descubrir', 'Discover')}
        </span>
        <div className="w-[1px] h-12 bg-white/30 relative overflow-hidden" data-id="element-229" data-mp="unraoxe69lte">
          <motion.div className="absolute top-0 left-0 w-full h-1/2 bg-white" animate={{
          top: ['-50%', '100%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} data-id="element-230" data-mp="zkrawrocbucl" />
        </div>
      </motion.div>
    </section>;
}